<div class="header">
  <div class="container">
    <app-error-banner></app-error-banner>

    <div class="header-desktop d-none d-sm-flex align-items-center">
      <div class="col-5">
        <span class="phone-number">{{ dataService.PhoneNumber | phone }}</span>
      </div>
      <div class="col-7 d-flex justify-content-end align-items-center">
        <span class="admin-label">Administered by</span>
        <img class="logo" src="assets/images/wellfit-plans%201.svg" *ngIf="eventsManager.legalLanguage.adminBy == 'wellfit'" alt="wellfit" />
        <span class="admin-label" *ngIf="eventsManager.legalLanguage.adminBy == 'careington'">Careington</span>
      </div>
    </div>

    <div class="header-mobile d-inline d-sm-none align-items-center">
      <img class="logo-small" src="assets/images/small-logo.png" alt="logo" />
      <span class="pipe">|</span>
      <span class="phone-number">{{ dataService.PhoneNumber | phone }}</span>
    </div>
  </div>
</div>
